import './initializers/axios';
import './initializers/consent-banner';

import NotifierPlugin from '@/plugins/notifier';
import ToastPlugin from '@/plugins/toast';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { createPinia } from 'pinia';

import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import { defaultMessages } from './lang/default';
// Keep the initializers before the other imports from this repo.
import { register as registerSwiper } from 'swiper/element/bundle';
import router from './router';

declare global {
  interface Window {
    // ToDo review this props
    productsUIEvents: any;
    backstageAppEvents: any;
    backstageApp: any;
    dataLayer: any[];
    newrelic: BrowserAgent;
  }
}

// register Swiper custom elements
registerSwiper();

const app = createApp(App);

app.use(createPinia());
app.use(createI18n({ legacy: false, locale: 'default', messages: { default: defaultMessages } }));
app.use(router);
app.use(NotifierPlugin);
app.use(ToastPlugin);

app.config.errorHandler = (err) => {
  throw err; // rethrow
};

app.mount('#backstage-ui');
